import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import KpiDeltaPercent from './KpiDeltaPercent';
import KpiPriorPeriod from './KpiPriorPeriod';
import styles from './styles/kpi-delta.module.scss';

/**
 * Prior-period delta row for KPI cards. Composes `KpiDeltaPercent`
 * (the +/- value) with `KpiPriorPeriod` (the optional tooltip label).
 * The `tone` prop drives muted-text color so the row reads correctly
 * on both the white surface and the navy highlight gradient.
 *
 * Returns `null` when `change` is `null`/`undefined` so consumers can
 * pass the prop unconditionally.
 */
function KpiDelta({ change, tooltip, tone }) {
    if (change == null) {
        return null;
    }

    const rowClassName = tone === 'highlight'
        ? `${styles.deltaRow} ${styles.deltaRowHighlight}`
        : styles.deltaRow;

    return (
        <div className={rowClassName}>
            <KpiDeltaPercent change={change} />
            <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.priorPeriod}>
                vs{' '}
            </Text>
            <KpiPriorPeriod tooltip={tooltip} />
        </div>
    );
}

export default KpiDelta;
